import * as form from '../form';

export const financialChildSupport = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        RecipientName: form.name(xitem.RecipientName),
        AmountRequiredToPay: form.number(xitem.AmountRequiredToPay),
        AmountPastDue: form.number(xitem.AmountPastDue),
        AmountPastDueEstimated: form.checkbox(xitem.AmountPastDueEstimated),
        ReasonPastDue: form.textarea(xitem.ReasonPastDue),
        WhenPastDue: form.datecontrol(xitem.WhenPastDue),
        WhenPastDueEstimated: form.checkbox(xitem.WhenPastDueEstimated),
        CurrentlyPastDue: form.branch(xitem.CurrentlyPastDue),
        WhenBecameCurrent: form.datecontrol(xitem.WhenBecameCurrent),
        ActionsTaken: form.textarea(xitem.ActionsTaken),
        ActionsTakenNone: form.notapplicable(xitem.ActionsTakenNone),
        ActionsTakenReason: form.textarea(xitem.ActionsTakenReason),
        CourtName: form.text(xitem.CourtName),
        CourtLocation: form.location(xitem.CourtLocation),
        OrderNum: form.text(xitem.OrderNum),
        OrderNumIdk: form.notapplicable(xitem.OrderNumIdk),
      },
    };
  });
  return {
    HasChildSupport: form.branch(data.HasChildSupport),
    HasChildSupportNotApplicable: form.notapplicable(data.HasChildSupportNotApplicable),
    List: form.collection(items, (data.List || {}).branch),
  };
};
